import React, { useEffect, useState } from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  BarChart, Bar,
} from 'recharts';
import { getLearningOutcomes, LearningOutcomesData } from '../../services/adminApi';

export const LearningOutcomes: React.FC = () => {
  const [data, setData] = useState<LearningOutcomesData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getLearningOutcomes()
      .then(setData)
      .catch(() => setError('Failed to load learning outcomes'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading learning outcomes...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data) return null;

  return (
    <div className="admin-chart-container">
      <div className="admin-kpi-card" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
        <div className="admin-kpi-value">{data.avg_time_to_mastery_days} days</div>
        <div className="admin-kpi-label">Avg Time to Mastery</div>
      </div>

      <h3>Mastery Achievements / Week</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data.mastery_per_week}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" tick={{ fontSize: 11 }} />
          <YAxis />
          <Tooltip />
          <Area type="monotone" dataKey="count" stroke="#22c55e" fill="#bbf7d0" name="Mastery Achieved" />
        </AreaChart>
      </ResponsiveContainer>

      <h3 style={{ marginTop: '2rem' }}>Gate Pass Rates / Week</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data.gate_pass_rates}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" tick={{ fontSize: 11 }} />
          <YAxis yAxisId="left" />
          <YAxis yAxisId="right" orientation="right" unit="%" />
          <Tooltip />
          <Legend />
          <Bar yAxisId="left" dataKey="total" fill="#94a3b8" name="Attempts" />
          <Bar yAxisId="left" dataKey="passed" fill="#22c55e" name="Passed" />
          <Bar yAxisId="right" dataKey="rate" fill="#3b82f6" name="Pass Rate %" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
